import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=32101c2a&scoped=true&"
import script from "./addView.vue?vue&type=script&lang=js&"
export * from "./addView.vue?vue&type=script&lang=js&"
import style0 from "./addView.vue?vue&type=style&index=0&id=32101c2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32101c2a",
  null
  
)

export default component.exports